<template>
  <div class="modal-holder">
    <!-- Product Region  -->
    <section class="product-region">
      <!-- Image Here -->
      <div class="image-region">
        <div class="image">
          <div v-if="isHEIC" class="image-holder">
            <span v-if="imageUrl === null"> Loading... </span>
            <span v-else>
              <img
                :src="imageUrl"
                alt="image"
                @error="handleBrokenImage($event)"
              />
            </span>
          </div>
          <div v-else class="image-holder">
            <img
              :src="product.image"
              alt="image"
              @error="handleBrokenImage($event)"
            />
          </div>
        </div>
      </div>

      <!-- Product Details -->
      <div
        class="product-details"
        :class="{ 'modal-overflow': product.option.length > 4 }"
      >
        <!-- <p class="price" v-if="product.price">${{ product.price }} 09</p> -->

        <div
          class="dropdown-holder"
          v-for="(option, i) in product.option"
          :key="i"
        >
          <p>Select {{ Object.keys(option)[0] | capitalize }}</p>
          <Select
            ref="selectedItem"
            :product="product"
            :selectedItems="selectedItems"
            :option="product.option[i]"
          />
        </div>
      </div>
    </section>

    <section class="button-region">
      <button class="finalize-button" @click="hadleSelection">
        apply
      </button>
    </section>
  </div>
</template>

<script>
import { handleBrokenImage } from '@/helpers'
import HEICConversion from '../../../mixins/HEICConversion'
import Select from './SingleSelect.vue'
export default {
  name: 'Singleproduct',
  components: { Select },
  mixins: [HEICConversion],
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    selectedItems: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    handleBrokenImage: handleBrokenImage,
    selectedItem: ''
  }),

  computed: {
    isDisabled() {
      const product = this.selectedItems.find(
        item => item.id == this.product.id
      )
      if (product.option !== undefined) {
        const isDisabled = Object.values(product.option).some(option => !option)
        return isDisabled
      } else {
        const isDisabled = Object.values(
          product.admin_order_product_option_sets
        ).some(option => !option)
        return isDisabled
      }
    }
  },
  mounted() {
    this.checkHEIC(this.product.image, this.product.fileType)
    if (this.checkKey('default')) {
      if (this.product.option.length === 1) {
        this.selectedItem = this.product.option[0].default[0]
      }
    }
  },
  methods: {
    hadleSelection() {
      const validations = this.$refs.selectedItem
      const isValid = validations.every(
        validation => validation.isSelectedValid !== ''
      )
      validations.forEach(item => {
        if (item.isSelectedValid === '') {
          item.$data.showValidationError = true
        }
      })
      if (isValid) {
        this.$emit('persistData')
      }
    },

    setValue(id, option) {
      const product = this.selectedItems.find(item => item.id == id)
      if (product) {
        if (product.option !== undefined) {
          const value = product.option[option]
          return value || ''
        } else {
          const value = product.admin_order_product_option_sets[option]
          return value || ''
        }
      }
    },
    updateSelection(value, option) {
      this.$emit('updateSelection', {
        id: this.product.id,
        option,
        value: this.selectedItem
      })
    },
    checkKey(key) {
      const targetKey = key
      let hasKey = false

      this.product.option.forEach(obj => {
        if (obj.hasOwnProperty(targetKey)) {
          hasKey = true
          return
        }
      })
      return hasKey
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.modal-holder {
  padding: 0 1.5rem;
  .product-region {
    margin-top: 2.5rem;
    display: flex;

    .image-region {
      width: 100%;
      height: 302px;

      .image {
        border: 1px solid #232220;
        padding: 0.75rem;
        height: 100%;
        width: 243px;
        display: flex;
        justify-content: center;
        align-items: center;

        .image-holder {
          height: 212px;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }

    .product-details {
      width: 100%;
      text-align: left;
      .price {
        color: #25282a;
        font-size: 1.25rem;
        font-weight: bold;
        margin-bottom: 1rem;
      }

      .dropdown-holder {
        margin-bottom: 1rem;

        p {
          font-size: 0.813rem;
          color: #232220;
          font-weight: bold;
          margin-bottom: 0.25rem;
        }
      }
    }
  }

  .button-region {
    display: flex;
    justify-content: end;
    margin-top: 4rem;

    .finalize-button {
      background: #24292c;
      color: $main-white;
      font-size: 1rem;
      font-weight: normal;
      font-size: 0.813rem;
      height: 2.5rem;
      text-transform: uppercase;
      border-radius: 40px;
      padding: 0 2rem;
      display: flex;
      align-items: center;
      justify-content: center;

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }
}

@media (max-width: 575.98px) {
  .image-region {
    margin-bottom: 2rem;
  }
  .product-region {
    flex-wrap: wrap;
  }

  .price {
    margin-top: 1rem;
  }

  .button-region {
    margin-top: 2rem !important;
    padding-bottom: 5rem;
  }

  .image {
    width: 100% !important;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .image-region {
    margin-bottom: 2rem;
  }
  .product-region {
    flex-wrap: wrap;
  }
  .price {
    margin-top: 1rem;
  }

  .button-region {
    margin-top: 2rem !important;
    padding-bottom: 5rem;
  }

  .image {
    width: 100% !important;
  }
}
</style>
